import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CanDeactivateComponent } from '../_helpers/can-deactivate.guard';

/**
 * Bridge tra il SpedizioneManualeBaseComponent (target del routing, ospita IonNav) e il
 * SpedizioneManualeComponent figlio (montato dentro IonNav).
 * Il figlio si registra in ngOnInit e si deregistra in ngOnDestroy.
 * Il guard CanDeactivate sulla route '' chiama getCanDeactivate() del Base, che delega al figlio.
 */
@Injectable({ providedIn: 'root' })
export class SpedizioneManualeDeactivateService {
  private current: CanDeactivateComponent | null = null;

  register(component: CanDeactivateComponent): void {
    this.current = component;
  }

  unregister(component: CanDeactivateComponent): void {
    if (this.current === component) {
      this.current = null;
    }
  }

  canDeactivate(): Observable<boolean> {
    return this.current ? this.current.canDeactivate() : of(true);
  }

  // Spegnimento forzato (senza dialog) della risorsa eventualmente attiva sul figlio registrato.
  // Chiamato dal logout automatico per inattività prima della revoca token/redirect: vedi
  // CanDeactivateComponent.forceDeactivate per il motivo.
  async forceDeactivate(): Promise<void> {
    if (this.current?.forceDeactivate) {
      await this.current.forceDeactivate();
    }
  }
}
